export const loyalty_card = {
    name: 'loyalty_card',
    params: {
        entityConfig: {
            name: 'loyalty_card',
        },
        types: ['barcode', 'magnentic' , 'qrcode', 'nfc', 'misc']
    }
};
